// Copyright 2019 Amplify Inc. All Rights Reserved.

/**
 * @fileoverview Constants for configuration option keys.
 * @author jgraham@amplify.com (Jessica Graham)
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENVIRONMENTS = exports.TRACKING_OPTIONS = exports.CONFIG_OPTIONS = void 0;
var CONFIG_OPTIONS = {
  APP_NAME: 'appName',
  APP_VERSION: 'appVersion',
  LANGUAGE: 'language',
  ENVIRONMENT: 'environment',
  USER_ID: 'userId'
};
exports.CONFIG_OPTIONS = CONFIG_OPTIONS;
var TRACKING_OPTIONS = {
  AUTO_UNLOAD: 'autoUnload',
  TRACK_APP_LOAD: 'trackAppLoad',
  TRACK_APP_UNLOAD: 'trackAppUnload',
  STASH_APP_UNLOAD_EVENT: 'stashAppUnloadEvent',
  TRACK_PAGE_OPEN: 'trackPageOpen',
  TRACK_PAGE_CLOSE: 'trackPageClose',
  STASH_FINAL_PAGE_CLOSE_EVENT: 'stashFinalPageCloseEvent',
  TRACK_PAGES_BY_HASH_CHANGE: 'trackPagesByHashChange'
};
exports.TRACKING_OPTIONS = TRACKING_OPTIONS;
var ENVIRONMENTS = {
  DEVCI: 'devci',
  SYSTEST: 'systest',
  STAGING: 'staging',
  PRODUCTION: 'prod'
};
exports.ENVIRONMENTS = ENVIRONMENTS;